// extracted by mini-css-extract-plugin
export default {"wrapper":"i0Izfgqh","dragging":"CGw64l2Q","pill":"jOD8sNrH","squeezeA":"bNrolDK3","squeezeB":"S5VEjmeu","pillSqueeze":"SEkV3eDg"};